

import { FC } from 'react';
import { ProgressBar, Row, Col, Form } from "react-bootstrap";
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faMoneyBill, faMoneyBillTransfer } from '@fortawesome/free-solid-svg-icons';
import storageService from "../../services/storage.service";
import HelperService from "../../services/helper.service";

interface IProps {
  predict_pickups_monetary_limit: boolean;
  percValueMonetary: number;
  variantValueMonetary: string;
  cellInfoMonetary: number;

  predict_pickups_physical_limit: boolean
  valueBanknotes: number;
  valuePercentBanknotes: number;
  variantBanknotes: string;
  columnId: string;
}


const formatToCurrency = (value) => {
  const user = storageService.getUser();
  let decimalSeparator = user.locale?.decimalSeparator;
  let thousandSeparator = user.locale?.thousandSeparator;
  return HelperService.number_format_abbreviated(value, 2, decimalSeparator, thousandSeparator);
};

export const ProgressBarLegend: FC<IProps> = ({
  predict_pickups_monetary_limit,
  percValueMonetary,
  variantValueMonetary,
  cellInfoMonetary,

  predict_pickups_physical_limit,
  valueBanknotes,
  valuePercentBanknotes,
  variantBanknotes,
  columnId
}) => {
  var columnSize = (columnId === "d01Value") ? 9: 12  ;
  return (
    <div style={{ minHeight: 90 }}>
      {predict_pickups_monetary_limit &&
        <>
          <Row>
            {columnId == "d01Value" &&
              <Col sm={2} md={2} lg={2}>
                
              </Col>
            }
            <Col sm={columnSize} md={columnSize} lg={columnSize}>
              <Form.Label className='mb-0'>
                <span
                  style={{
                    fontSize: '0.85rem',
                    fontWeight: 'bold',
                    color: 'rgb(0,57,166)'
                  }}
                > {formatToCurrency(cellInfoMonetary)}</span>
              </Form.Label>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12}>
              <ProgressBar
              className='mt-1'
                now={percValueMonetary}
                label={`${percValueMonetary.toFixed(0)}%`}
                variant={variantValueMonetary}
              />
            </Col>
          </Row>
        </>
      }

      {predict_pickups_physical_limit &&
        <>
          <Row>
            {columnId == "d01Value" &&
              <Col sm={1} md={1} lg={1}>
                
              </Col>
            }
            <Col sm={columnSize} md={columnSize} lg={columnSize}>
              <Form.Label className='mb-0 mt-1'>
                <span
                  style={{
                    fontSize: '0.85rem',
                    fontWeight: 'bold',
                    color: 'rgb(0,57,166)'
                  }}
                > {valueBanknotes} </span>
              </Form.Label>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12}>
              <ProgressBar
                now={valuePercentBanknotes}
                label={`${valuePercentBanknotes.toFixed(0)}%`}
                variant={variantBanknotes}
              />
            </Col>
          </Row>
        </>
      }

    </div>
  );
}

export default ProgressBarLegend;